module.exports = __webpack_public_path__ + "img/bim7.b183115c.png";